import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import ConditionError from '../common/ConditionError';
import EditorConditionInputs from './EditorConditionInputs';
import EditorRelatedConditionsGroupContainer from './EditorRelatedConditionsGroupContainer';
import { getBaseEventBasedFilterFamilyField } from '../../strategy/eventBasedFilters';
import { useMemo } from 'react';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorCommunicationSubscriptionRelatedConditionsGroup = props => {
  const {
    filterFamily,
    condition,
    conditionPath,
    dataSeleniumInfo
  } = props;
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const statusCondition = useMemo(() => {
    return condition.set('field', getBaseEventBasedFilterFamilyField(filterFamily));
  }, [condition, filterFamily]);
  const heading = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
      condition: statusCondition,
      dataSeleniumInfo: dataSeleniumInfo,
      filterFamily: filterFamily,
      onConditionOperatorChange: onFieldConditionOperatorChange,
      onConditionValueChange: onFieldConditionValueChange
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
  return /*#__PURE__*/_jsx(EditorRelatedConditionsGroupContainer, {
    condition: condition,
    dataSeleniumInfo: dataSeleniumInfo,
    heading: heading,
    onGroupDelete: () => onConditionDelete(conditionPath)
  });
};
export default EditorCommunicationSubscriptionRelatedConditionsGroup;